import { ChangeEventHandler } from 'react';

import { useFocus } from '../hooks';
import { UseInputValueInternal } from '../hooks/types';
import { getInputStateType } from './getInputStateType';
import { UseInput } from './types';

const noopOnChange: ChangeEventHandler<HTMLInputElement> = () => {};
const noopValidate = () => true;

const useInputValueInternal: UseInputValueInternal = ({
  value = '',
  onChange = noopOnChange,
}) => ({
  value,
  onChange,
});

export const useInput: UseInput = ({
  disabled,
  validate = noopValidate,
  ...rest
}) => {
  const inputValueProps = useInputValueInternal(rest);
  const focusProps = useFocus(rest);
  const invalid = !validate(inputValueProps.value);
  const stateType = getInputStateType({ disabled, invalid, ...focusProps });
  return {
    ...rest,
    disabled: !!disabled,
    invalid,
    stateType,
    ...inputValueProps,
    ...focusProps,
  };
};
